import { createSlice } from "@reduxjs/toolkit";
import { InitialPlasticTypeFormData } from "../../ConstantData/InitialData";

const plasticTypeSlice = createSlice({
  name: "plastictype",
  initialState: {
    plasticTypeList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    initialData: InitialPlasticTypeFormData,
  },
  reducers: {
    getAllPlasticType: (state, action) => {
      state.plasticTypeList = action.payload;
    },
    getPlasticType: () => {},
    getPlasticTypeDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialPlasticTypeFormData };
    },
    updatePlasticType: (state, action) => {},
    deletePlasticType: () => {},
  },
});

export const plasticTypeSliceAction = plasticTypeSlice.actions;

export default plasticTypeSlice.reducer;
